import { useState } from "react";
import { Modal, Form, Spinner } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";
import { DropdownSelect } from "components/DropdownSelect";
import { useEmpresas } from "hooks/useEmpresas";
import { TipoLote } from "../../interfaces/ILoteEstampagem";

interface ICriarLoteModalProps {
  show: boolean;
  loading: boolean;
  tipoInicial?: TipoLote;
  onFechar: () => void;
  onContinuar: (dados: { idEmpresa: number; nomeEmpresa: string; localEntrega?: string; comTag: boolean; tagJaRegistrada: boolean; tipo: TipoLote }) => void;
}

export function CriarLoteModal({ show, loading, tipoInicial = 'ESTAMPAGEM', onFechar, onContinuar }: ICriarLoteModalProps) {
  const { empresasOptions, empresas } = useEmpresas();
  const [tipo, setTipo] = useState<TipoLote>(tipoInicial);
  const [idEmpresa, setIdCliente] = useState<number | "">("");
  const [localEntrega, setLocalEntrega] = useState("");
  const [comTag, setComTag] = useState(false);
  const [tagJaRegistrada, setTagJaRegistrada] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!idEmpresa) {
      setErro("Selecione a empresa");
      return;
    }
    const empresa = empresas.find((emp) => emp.id === idEmpresa);
    if (!empresa) {
      setErro("Empresa não encontrada");
      return;
    }
    setErro(null);
    onContinuar({
      idEmpresa: Number(idEmpresa),
      nomeEmpresa: empresa.razao_social,
      localEntrega: localEntrega.trim() || undefined,
      comTag: tipo === 'TAGS' ? true : comTag,
      tagJaRegistrada: tipo === 'TAGS' ? false : tagJaRegistrada,
      tipo,
    });
  }

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered onHide={onFechar}>
      <Modal.Header closeButton>
        <Modal.Title>Novo Lote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex gap-2 mb-4 flex-wrap">
          <PrimaryButton
            variante="primary"
            outline={tipo !== 'ESTAMPAGEM'}
            buttonWidth="lg"
            buttonWidthTipo="px"
            onClick={() => setTipo('ESTAMPAGEM')}
          >
            Estampagem
          </PrimaryButton>
          <PrimaryButton
            variante="primary"
            outline={tipo !== 'TAGS'}
            buttonWidth="lg"
            buttonWidthTipo="px"
            onClick={() => setTipo('TAGS')}
          >
            Somente Tags
          </PrimaryButton>
        </div>
        <Form id="form-criar-lote" onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Empresa</Form.Label>
            <DropdownSelect
              options={empresasOptions}
              title="Selecione a empresa"
              searchable
              selectedValue={idEmpresa}
              onSelect={(v) => setIdCliente(v === "" ? "" : Number(v))}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Local de Entrega</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ex: PDI TEGMA, Pátio A..."
              value={localEntrega}
              onChange={(e) => setLocalEntrega(e.target.value)}
              maxLength={200}
            />
          </Form.Group>
          {erro && <div className="text-danger mb-2">{erro}</div>}
          {tipo === 'ESTAMPAGEM' && (
            <>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  id="com-tag-switch"
                  label="Com Tag (leitura de QR code)"
                  checked={comTag}
                  onChange={(e) => { setComTag(e.target.checked); if (!e.target.checked) { setTagJaRegistrada(false); } }}
                />
              </Form.Group>
              {comTag && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="switch"
                    id="tag-ja-registrada-switch"
                    label="Tag já registrada (buscar tag do banco por placa)"
                    checked={tagJaRegistrada}
                    onChange={(e) => setTagJaRegistrada(e.target.checked)}
                  />
                </Form.Group>
              )}
            </>
          )}
          {tipo === 'TAGS' && (
            <div className="alert alert-info py-2 mb-0" style={{ fontSize: "0.85rem" }}>
              Importar planilha com lista de placas e vincular TAGs individualmente.
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton type="submit" form="form-criar-lote" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Continuar"}
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  );
}
